import { Component, Input } from '@angular/core';
import { TransitSummary } from '../../../../models/transit/transit.models';

@Component({
  selector: 'transit-preview',
  templateUrl: 'transit-preview.html'
})
export class TransitPreviewComponent {
  @Input() transitSummary: TransitSummary;
  @Input() locationChanged: boolean;

  constructor() {

  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/shared/components/transit-preview/transit-preview.ts